import { setItem } from "../../common/localStorage";

export const getProductParentRoute = (state = {}, getFeatureFromGroup) => {
  if (state?.viewProduct) {
    return "/view-product";
  }

  if (state?.manageProduct) {
    return "/edit-product";
  }

  if (getFeatureFromGroup?.groupLevelModification) {
    return "/edit-group-product";
  }

  return "/addproduct";
};

export const getProductFeatureNavigateUrl = (
  navigate,
  item,
  productData,
  { viewProduct = false, manageProduct = true } = {},
) => {
  const navigationState = {
    item,
    productData,
    manageProduct,
    viewProduct,
  };

  switch (item?.refFeatureId) {
    case 9:
      navigate("/disclaimers", { state: navigationState });
      break;
    case 3:
      navigate("/access-membership", { state: navigationState });
      break;
    case 1:
      navigate("/membership-benefits", { state: navigationState });
      break;
    case 2:
      navigate("/plan-information", { state: navigationState });
      break;
    case 7:
      navigate("/summary-plan-description", { state: navigationState });
      break;
    case 12:
      navigate("/schedule-care", { state: navigationState });
      break;
    case 8:
      navigate("/insurance-certification", { state: navigationState });
      break;
    case 5:
      navigate("/digitized-id-card", { state: navigationState });
      break;
    case 11:
      navigate("/claim", {
        state: { state: item, productData, manageProduct, viewProduct },
      });
      break;
    case 10:
      navigate("/edit-faq", { state: navigationState });
      break;
    case 6:
      navigate("/benefits-history", { state: navigationState });
      break;
    case 4:
      navigate("/dpc-extra", { state: navigationState });
      break;
    default:
      navigate("/disclaimers", { state: navigationState });
      break;
  }

  setItem("refFeatureId", item?.refFeatureId);
  setItem("featureName", item?.featureName);
};
